/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableWedge.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1120
 * ---
 * Description:
 */

import { ObservableShape } from './ObservableShape';
import Pamela              from '@revodigital/pamela';

export class ObservableWedge extends ObservableShape<Pamela.Wedge> {
  constructor(shape: Pamela.Wedge, editor: any) {
    super(shape, editor);
    //makeObservable(this, undefined, { autoBind: true, deep: true, });
  }
}